import { Directive } from '@angular/core';

/**
 * Carte blanche bordée de la maquette : fiche producteur, bloc de produit,
 * encart de tableau de bord.
 *
 * Aucune option : la maquette n'emploie qu'une seule variante, et l'écart entre
 * les cartes se fait par leur contenu, pas par leur cadre.
 */
@Directive({
  selector: '[ctCard]',
  host: { class: 'ct-card' },
})
export class CtCard {}
